import { TableCell } from "@mui/material";
import { useState } from "react";
import { Button, Modal } from "src/Components";
import InsMarginConfig from "./InsMarginConfig";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { IQueueStatusTableReport } from "src/Interfaces/applyOption";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IQueueStatusTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <TableCell>
        {isModalOpen ? (
          <Modal
            title="تنظیم وجه تضمین"
            UI={
              <InsMarginConfig
                row={row}
                onClose={() => {
                  setIsModalOpen(false);
                  onAction();
                }}
              />
            }
            onClose={() => setIsModalOpen(false)}
            modalBoxClassName="!min-w-[300px] !min-h-[200px]"
          />
        ) : null}
        <Button
          onClick={() => setIsModalOpen(true)}
          text="ویرایش"
          variant="contained"
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IQueueStatusTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
